export const EXTENSION_POPUP = 'FidMarques Browser Extension - Popup'
export const EXTENSION_CONTENT_SCRIPT = 'FidMarques Browser Extension - Message Bus'

export const WIDGET_BRIDGE = 'FidMarques Web Widget - Bridge'
export const WIDGET_IFRAME = 'FidMarques Web Widget - Iframe'
